<template>
    <div>
        <div class="row" v-for="(plan, index) in plans">
            <div class="col s2">
                {{$t('plans.date_of_issue')}}:
            </div>
            <div class="col s2 input-field">
                <input :id="'place_plans_'+(plan.id || plan.timestamp)+'_date'" type="date" class="datepicker" v-model="plan.date">
            </div>
            <div class="col s1">
                <label :for="'place_plans_planfile_'+(plan.id || plan.timestamp)" v-if="!plan.attachment">
                {{ plan.file == undefined ? "Wybierz plik" : plan.file.name }}
            </label>
                <input type="file" :id="'place_plans_planfile_'+(plan.id || plan.timestamp)" @change="setFile(plan, $event.target.name, $event.target.files)" v-if="!plan.attachment" :disabled="editplans == false" hidden>
                <a :href="plan.attachment" v-if="plan.attachment"><i class="material-icons">insert_drive_file</i></a> 
            </div>
            <div class="col s1">
                <modal identifier="leaveeditquestion" ref="questionremoveplan" :question="$t('plans.delete_question')" :cancelText="$t('menu.buttons.cancel')" :confirmText="$t('menu.buttons.delete')" :showTrigger="true" v-on:onConfirm="removeDocument(plan)" :questionrichtext="$t('plans.delete_question_rich')"></modal>
            </div>
            <button class="waves-effect waves-light btn-large green" v-on:click="openPlan(plan)">Podgląd</button>
            <div class="col s12">
                <plan v-if="plan.open" :plan="plan"/>
            </div>
        </div>
        <div class="row">
            <div class="col s2" v-if="place.editable">
                <a v-on:click="addPlan()" class="waves-effect waves-light btn-large green">
                    {{ $t('plans.add') }}
                </a>
            </div>
            <div class="col offset-s4 s6">
                <a v-on:click="cancelEditPlans()" class="waves-effect waves-light btn-large cancelbutton" v-if="editplans == true">{{$t('menu.buttons.cancel_changes')}}</a>
                <a v-if="plans.length > 0 && editplans == false && place.editable" v-on:click="editPlans()" class="waves-effect waves-light btn-large emptygreen">{{$t('menu.buttons.edit')}}</a>
                <a v-on:click="savePlans()" class="waves-effect waves-light btn-large emptygreen" v-if="editplans">
                    <div v-if="saving" class="preloader-wrapper small active">
                        <div class="spinner-layer spinner-red-only">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="gap-patch">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper right">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                    {{saving == false ? $t('menu.buttons.save_changes') : ""}}
                </a>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import _ from 'lodash';
import moment from 'moment';
export default {
    data: function() {
        return {
            old_plans: [],
            editplans: false,
            saving: false
        }
    },
    mounted: function() {},
    methods: {
         savePlans: async function() {
            this.savingdocuments = true
            var docs = 0;
            const formData = new FormData();
            console.log(this.plans);
            for (var doc of this.plans) {
            	console.log(doc);
                if (doc.id) formData.append('place[documents_attributes][' + docs + '][id]', doc.id);
                formData.append('place[documents_attributes][' + docs + '][doctype]', doc.doctype);
                formData.append('place[documents_attributes][' + docs + '][date]', doc.date);
                if (doc.file) formData.append('place[documents_attributes][' + docs + '][attachment]', doc.file);
                if (doc.destroy) formData.append('place[documents_attributes][' + docs + '][_destroy]', true);
                docs += 1;
            }
            
            var response = await axios.put('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '.json', formData)
            this.savingdocuments = false;
            this.editplans = false;
            this.errors = {};
            this.old_settings = _.cloneDeep(response.data)
        },
        openPlan(plan){
	  plan.open = true;
          this.$forceUpdate();
        },
        addPlan() {
            if (this.editplans == false) this.editPlans();
            this.place.documents.push({
                date: moment().format("YYYY-MM-DD"),
                doctype: "plan",
                timestamp: moment().unix()
            });
        },
        editPlans() {
            this.old_plans = _.cloneDeep(this.place.documents);
            this.editplans = true;
        },
        setFile: function(doc, name, file) {
            doc.file = file[0];
            this.$forceUpdate();
            console.log(doc);
        },
        cancelEditPlans() {
            this.editplans = false;
            this.place.documents = this.old_plans
        },
        removeDocument: function(doc) {
            if (_.isUndefined(doc.id)) {
                this.place.documents.splice(this.place.documents.indexOf(doc), 1)

            } else {
                doc._destroy = true;
                const formData = new FormData();
                formData.append('place[documents_attributes][0][id]', doc.id);
                formData.append('place[documents_attributes][0][_destroy]', true);
                axios.put('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '.json', formData).then(response => {
                    this.savingcontacts = false;
                    this.editcontacts = false;
                    this.errors = {};
                    this.place.documents.splice(this.place.documents.indexOf(doc), 1)
                })
                this.$forceUpdate();
            }
        },
    },
    props: { place: Object },
    computed: {
        plans: function() {
            return _.chain(this.place.documents).filter(function(doc) {
                return doc.doctype == "plan";
            }).sort(function(a, b){ return moment(a.old_date, 'YYYY-MM-DD').unix() - moment(b.old_date, 'YYYY-MM-DD').unix() }).each(function(item){item.open = false;}).value();
        },
    },

}
</script>
<style scoped>
div {
    margin-left: auto;
    left: auto;
    right: auto;
    line-height: 2;
}
</style>
